var _style, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path3, _path4, _path5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path6, _ellipse13, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarthSidiusHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0dsh{fill:#7F7F80;}\r\n\t.st1dsh{fill:#6E6E6D;}\r\n\t.st2dsh{fill:#7F734C;}\r\n\t.st3dsh{fill:#DAA722;}\r\n\t.st4dsh{fill:#BFBDBB;}\r\n\t.st5dsh{fill:#9E9E9E;}\r\n\t.st6dsh{fill:#262626;}\r\n\t.st7dsh{fill:#AFAEAC;}\r\n\t.st8dsh{fill:#555454;}\r\n\t.st9dsh{fill:#8D692B;}\r\n\t.st10dsh{fill:#424242;}\r\n\t.st11dsh{fill:#DAA621;}\r\n\t.st12dsh{fill:#C19121;}\r\n\t.st13dsh{fill:#9E741D;}\r\n\t.st14dsh{fill:#825D1A;}\r\n\t.st15dsh{fill:#5E5332;}\r\n\t.st16dsh{fill:#7F7144;}\r\n\t.st17dsh{fill:#706539;}\r\n\t.st18dsh{fill:#564E37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0dsh",
    d: "M25,19c0.7,0,2.7,0.1,4.4,2c0.7,0.8,1.2,1.7,1.4,2.3c0.2,0,2.4-0.5,2.8-2.1c0.1-0.4,0-1.2-0.3-1.7 c0,0-0.2-0.3-0.5-0.5c-5.9-3.4-12.7-1.9-12.7-1.9c-5,1.1-11.3,1.9-19.9,2.4c0,0.1-0.6,1.7,0.1,2.9C1,23.6,2.6,24,3.9,22.8 c0.2-0.4,0.5-0.9,0.8-1.3c1.9-2.5,4.7-2.3,5.5-2.2C15.1,19.2,20.1,19.1,25,19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1dsh",
    d: "M7.9,12.3c-2.5,2.4-5.1,4.9-7.6,7.3c11,0,22,0,33.1,0c-2.7-2.7-5.5-5.4-8.2-8.1C19.4,11.8,13.7,12,7.9,12.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dsh",
    cx: 17.1,
    cy: 20.6,
    rx: 12.4,
    ry: 1.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dsh",
    cx: 17.1,
    cy: 24.2,
    rx: 13.7,
    ry: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dsh",
    cx: 17.1,
    cy: 27.9,
    rx: 13.7,
    ry: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dsh",
    cx: 17.1,
    cy: 31.5,
    rx: 13.7,
    ry: 2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dsh",
    cx: 17.1,
    cy: 35,
    rx: 13.7,
    ry: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3dsh",
    d: "M26.8,190.7c0,0.2-0.1,0.4-0.2,0.6c-1.4,3.4-8.8,1.5-10.1,1.1c-0.3,1.1-0.8,2.7-1.8,4.3 c-0.8,1.4-1.7,2.5-2.3,3.2c-0.4,0.1-2,0.2-3.5-1.2c-1.9-1.7-2.1-4.5-2.1-4.9c-0.3-1.2-0.5-2.6-0.6-4.2c-0.2-2.8-0.1-5.2,0.1-7 c-0.8-0.9-2.1-2.7-3-5.4c-1.1-3.3-1-6.3-0.9-7.7C10.5,176.5,18.7,183.6,26.8,190.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4dsh",
    d: "M28.5,58.8c-4.1,7.6-8.3,16.5-11.9,27c-10.9,31-12.3,60.1-11.8,78.8c1.8,3.8,3.5,7.6,5.3,11.4 c3.2,0.3,6.4,0.6,9.5,0.9c8.7-4.7,10.3-7.8,10.2-9.8c-0.2-2.2-2.5-3-3.3-6.5c-0.8-3.4,0.5-6.6,0.8-7.3c1.6-4.6,2.5-27.1,1.7-86.2 c0.8-2.5,1.7-5.1,2.5-7.6c-0.2-0.7-0.5-1.5-0.7-2.2C30,57.7,29.2,58.2,28.5,58.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5dsh",
    d: "M3.2,45.2c-0.2,0.5-0.5,1.3-0.8,2.4c-0.3,1.1-0.6,3.1-0.1,8.7c0.1,1.3,0.3,3,0.6,5.1 c0.3,28.2,0.6,56.5,0.9,84.7c-0.1,1-0.2,2.6-0.3,4.6c-0.5,5.8-1.1,7.8-1.3,11.2c-0.1,2.1-0.1,5.3,0.5,9.2c0.1,0.6,0.3,1.2,0.6,1.9 c0.8,2,1.9,3.3,2.7,4.1c2.1,2.5,4.8,5.3,8.2,7.9c4.8,3.7,9.3,5.7,12.7,6.9c0.7-0.5,2-1.6,3-3.6c0.6-1.3,0.9-2.5,1.1-3.4 c0.4-3.5,0.8-7,1.3-10.5c-0.3-0.4-0.6-1-0.8-1.7c-0.7-2.3-0.3-4.5-0.1-5.3c-0.1-0.3-0.4-0.8-0.8-1.2c-0.2-0.2-0.7-0.6-1.2-0.6 c-0.9,0-1.5,1.5-1.7,2c0,0-0.4,1-4.6,5.2c-1.1,1.1-3.9,3.2-10.4,2.2c-0.8-0.4-2.1-1.2-3.2-2.6c-3.1-3.9-3.3-9.8-3.5-17.1 c-0.1-2.7,0-6.5,0.4-11c1.7-13,4.4-28.1,8.7-44.4c3.5-13.1,7.4-24.6,11.2-34.6c1.4-2.7,3.9-7.2,4.5-6.7c0.6,0.4-0.8,5.2-1.7,8.3 c0.5-0.9,1.1-2,1.6-3.3c0.7-1.9,1.2-3.7,1.5-5.2c0.2-1.5,0.3-4.1-0.4-7.1c-0.4-1.8-1-3.2-1.5-4.1c-8.8-0.9-17.6-1.9-26.4-2.8 C3.5,44.7,3.3,45,3.2,45.2z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6597 -0.7516 0.7516 0.6597 -44.1129 38.2351)",
    className: "st6dsh",
    cx: 20.2,
    cy: 67.8,
    rx: 2.3,
    ry: 4.6
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6427 -0.7661 0.7661 0.6427 -49.0471 41.0261)",
    className: "st6dsh",
    cx: 19.5,
    cy: 73.1,
    rx: 1.6,
    ry: 3.6
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6606 -0.7507 0.7507 0.6606 -52.4007 40.612)",
    className: "st6dsh",
    cx: 18.7,
    cy: 78.3,
    rx: 1.3,
    ry: 2.6
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7094 -0.7048 0.7048 0.7094 -54.0666 36.8208)",
    className: "st6dsh",
    cx: 17.6,
    cy: 84,
    rx: 1,
    ry: 1.6
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.58 -0.8146 0.8146 0.58 -65.404 50.714)",
    className: "st6dsh",
    cx: 16.5,
    cy: 88.8,
    rx: 0.9,
    ry: 1.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dsh",
    cx: 22.2,
    cy: 58,
    rx: 4.2,
    ry: 5.5
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8dsh",
    cx: 22.9,
    cy: 58,
    rx: 2.1,
    ry: 2.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9dsh",
    d: "M34.1,175.6c-2.5-0.6-3.5-0.7-4-0.7c0,0,0,0,0,0c-0.6,0-1.1,3.4-0.9,6.2c0.1,0.9,0.3,2.3,0.9,3.8 c1.3-0.2,2.6-0.5,4-0.7C34.1,181.3,34.1,178.4,34.1,175.6z"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10dsh",
    cx: 34.1,
    cy: 179.9,
    rx: 0.9,
    ry: 4.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11dsh",
    d: "M3.7,37.1c-0.3,0.1-0.7,0.3-1.1,0.7c-0.7,0.9-0.7,2.1-0.8,4c-0.1,1.6-0.1,2.9,0.5,3.5c0.3,0.3,0.6,0.3,0.8,0.2 c4.5,0.3,9.1,0.7,13.9,1.3c5.2,0.6,10.1,1.4,14.9,2.3c0-3.2,0-6.4,0-9.6c0-0.4,0-0.9-0.1-1.4c-0.4-1.1-1.4-1.7-2.5-1.5 C20.8,36.7,12.3,36.9,3.7,37.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12dsh",
    d: "M27.2,37.9c-3.7-0.4-7.8-0.7-12.1-0.6c-2.4,0.1-4.6,0.2-6.8,0.4c-0.3,0-1.8-0.1-2.5,1.1 c-0.3,0.5-0.3,1.2-0.3,2.6c0,1.8,0,2.7,0.4,3.3c0.3,0.4,0.7,0.7,2.3,0.9c1.3,0.2,2,0.3,3.1,0.3c0,0,2,0.2,5.8,0.5 c4.2,0.4,8.1,0.7,10.5,0.9c0.3-2.1,0.5-4.9-0.1-8C27.5,38.8,27.4,38.3,27.2,37.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13dsh",
    d: "M18.9,45.4H17c-0.4,0-0.7-0.3-0.7-0.7v-5.3c0-0.4,0.3-0.7,0.7-0.7h1.9c0.4,0,0.7,0.3,0.7,0.7v5.3 C19.6,45.1,19.3,45.4,18.9,45.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14dsh",
    d: "M19.4,46.3c0-2.7,0-5.4,0-8.1c0.9,0,1.9,0.1,2.8,0.1c1.7,0,3.4,0.1,5.1,0.1c0.3,1.1,0.6,2.7,0.6,4.6 c0,1.7-0.1,3.2-0.3,4.3C24.9,46.9,22.2,46.6,19.4,46.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13dsh",
    d: "M27.6,39.3c-1-0.1-2.1-0.1-3.1-0.2c-0.2,1.1-0.3,2.9,0,4.9c0.2,1.3,0.5,2.4,0.8,3.2c0.8,0,1.6,0.1,2.4,0.1 c0.2-1.3,0.4-3,0.3-5.1C27.9,41.1,27.7,40.1,27.6,39.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15dsh",
    d: "M10.2,9C8.8,9.1,6.8,8.9,5,7.5C4.8,7.4,4.6,7.2,4.5,7.1C6.3,6.2,8.1,5.4,10,4.6C10.1,6,10.2,7.5,10.2,9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15dsh",
    d: "M23.7,9c1.5,0.1,3.5-0.2,5.3-1.5c0.2-0.1,0.4-0.3,0.5-0.4c-1.9-0.9-3.8-1.7-5.7-2.6C23.8,6,23.7,7.5,23.7,9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 3.7,
    className: "st16dsh",
    width: 14.4,
    height: 7.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st17dsh",
    d: "M4.5,7.1c2.7-1.3,6.8-2.8,12-2.9c5.7-0.1,10.2,1.5,13,2.9c0.1-0.1,0.9-0.8,0.9-2c0.1-1.4-0.9-2.3-0.9-2.3 c-2.8-1.3-7.3-2.9-13-2.9C11.3,0,7,1.5,4.3,2.8c-0.1,0.1-0.9,0.7-0.9,2C3.4,5.8,3.8,6.6,4.5,7.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st18dsh",
    d: "M9.5,9.5c-2,1.6-2.7,4.1-2.1,5.7c0.3,0.9,1.1,1.3,1.6,1.6c5.3,0,10.6,0,16,0c1-0.5,1.3-1.3,1.4-1.6 c0.5-1.6-0.3-4.2-2.5-5.8C19.1,9.4,14.3,9.5,9.5,9.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarthSidiusHilt);
export default __webpack_public_path__ + "static/media/darth-sidius-hilt.22237c3f.svg";
export { ForwardRef as ReactComponent };